/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_InvoicesInputs */

const en_no_invoices = /** @type {(inputs: No_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No invoices found.`)
};

const fr_no_invoices = /** @type {(inputs: No_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune facture trouvée.`)
};

const de_no_invoices = /** @type {(inputs: No_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurden keine Rechnungen gefunden.`)
};

const it_no_invoices = /** @type {(inputs: No_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna fattura trovata.`)
};

const ru_no_invoices = /** @type {(inputs: No_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Счета-фактуры не найдены.`)
};

const es_no_invoices = /** @type {(inputs: No_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron facturas.`)
};

const zh_cn2_no_invoices = /** @type {(inputs: No_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到发票。`)
};

const ja_no_invoices = /** @type {(inputs: No_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請求書が見つかりません。`)
};

const hi_no_invoices = /** @type {(inputs: No_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई बिल नहीं मिला।`)
};

const pt_pt2_no_invoices = /** @type {(inputs: No_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma fatura encontrada.`)
};

/**
* | output |
* | --- |
* | "No invoices found." |
*
* @param {No_InvoicesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_invoices = /** @type {((inputs?: No_InvoicesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_InvoicesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_no_invoices(inputs)
	if (locale === "de") return de_no_invoices(inputs)
	if (locale === "it") return it_no_invoices(inputs)
	if (locale === "ru") return ru_no_invoices(inputs)
	if (locale === "es") return es_no_invoices(inputs)
	if (locale === "zh-CN") return zh_cn2_no_invoices(inputs)
	if (locale === "ja") return ja_no_invoices(inputs)
	if (locale === "hi") return hi_no_invoices(inputs)
	if (locale === "pt-PT") return pt_pt2_no_invoices(inputs)
	return en_no_invoices(inputs)
});